/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuthSupportPagedList } from '../models/auth-support-paged-list';
import { personalSearchAuthSupports$Any } from '../fn/personal-space-subscription/personal-search-auth-supports-any';
import { PersonalSearchAuthSupports$Any$Params } from '../fn/personal-space-subscription/personal-search-auth-supports-any';
import { personalSearchAuthSupports$Json } from '../fn/personal-space-subscription/personal-search-auth-supports-json';
import { PersonalSearchAuthSupports$Json$Params } from '../fn/personal-space-subscription/personal-search-auth-supports-json';
import { personalSearchTransactions$Any } from '../fn/personal-space-subscription/personal-search-transactions-any';
import { PersonalSearchTransactions$Any$Params } from '../fn/personal-space-subscription/personal-search-transactions-any';
import { personalSearchTransactions$Json } from '../fn/personal-space-subscription/personal-search-transactions-json';
import { PersonalSearchTransactions$Json$Params } from '../fn/personal-space-subscription/personal-search-transactions-json';
import { TransactionPagedList } from '../models/transaction-paged-list';


/**
 * All about personal space subscription
 */
@Injectable({ providedIn: 'root' })
export class PersonalSpaceSubscriptionService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `personalSearchTransactions()` */
  static readonly PersonalSearchTransactionsPath = '/personalspace/transaction/search';

  /**
   * Search my transactions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personalSearchTransactions$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalSearchTransactions$Json$Response(params?: PersonalSearchTransactions$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return personalSearchTransactions$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search my transactions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personalSearchTransactions$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalSearchTransactions$Json(params?: PersonalSearchTransactions$Json$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.personalSearchTransactions$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /**
   * Search my transactions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personalSearchTransactions$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  personalSearchTransactions$Any$Response(params?: PersonalSearchTransactions$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return personalSearchTransactions$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search my transactions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personalSearchTransactions$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  personalSearchTransactions$Any(params?: PersonalSearchTransactions$Any$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.personalSearchTransactions$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `personalSearchAuthSupports()` */
  static readonly PersonalSearchAuthSupportsPath = '/personalspace/auth-support/search';

  /**
   * Search my auth supports, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personalSearchAuthSupports$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalSearchAuthSupports$Json$Response(params?: PersonalSearchAuthSupports$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportPagedList>> {
    return personalSearchAuthSupports$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search my auth supports, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personalSearchAuthSupports$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalSearchAuthSupports$Json(params?: PersonalSearchAuthSupports$Json$Params, context?: HttpContext): Observable<AuthSupportPagedList> {
    return this.personalSearchAuthSupports$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupportPagedList>): AuthSupportPagedList => r.body)
    );
  }

  /**
   * Search my auth supports, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personalSearchAuthSupports$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  personalSearchAuthSupports$Any$Response(params?: PersonalSearchAuthSupports$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportPagedList>> {
    return personalSearchAuthSupports$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search my auth supports, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personalSearchAuthSupports$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  personalSearchAuthSupports$Any(params?: PersonalSearchAuthSupports$Any$Params, context?: HttpContext): Observable<AuthSupportPagedList> {
    return this.personalSearchAuthSupports$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupportPagedList>): AuthSupportPagedList => r.body)
    );
  }

}
